<div>
  <div class="popup-bg">
  </div>

  <div class="popup-position container-fluid p-0 border-radius-25">
    <div class="white mystats in border-radius-25">
      <div class="row">
        <div class="col-md-11 popup-header" style="border-top-left-radius: 20px;">
          <p>
            De-Activate Module - {{client.Client_Name || "N/A"}} ({{client.Id}})
          </p>
        </div>
        <div class="col-md-1 popup-header closeIcon" style="border-top-right-radius: 20px;">
          <i title="Close Session Timeout" class="fa fa-close" (click)="closeModal()"></i>
        </div>
        <div class="col-md-12">
          <span class="form-group file-provider mt-10">
            <input name="file-upload-field" [(ngModel)]="Deactivate_Reason" type="text" class="form-control"
              placeholder="Enter Reason">
          </span>
          <span>
            <button type="button"
              [disabled]="Deactivate_Reason==null || Deactivate_Reason.length==0 || httpStatus==true"
              (click)="deActivateProject()"
              class="btn pr-upl label btn-default label-info-padding label-info square-btn cursor mr-10 mt-10" style="border: none;height: 30px !important;">
              De-Activate Module
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
